
import $ from 'jquery';

import {getViewControllerName} from '../general/Util';

export function switchPaymentMethods() {

	// Toggle Payment Methods.
	$( "#paymentid_form_1" ).val( $( ".radio[name='paymentid']:checked" ).val() );
	$( ".radio[name='paymentid']" ).on( 'click', function(){
		$( ".radio[name='paymentid']" ).removeAttr( 'checked' );
		$( this ).attr( 'checked', 'checked' );
		$( "#paymentid_form_1" ).val( $( this ).val() );
	} );
}

export function triggerFormBottomButton() {

	// Trigger Sticky Button for BuyNow.
	$( '#buyNowBottom' ).on( 'click', function( e ){
		e.preventDefault();
		$( '#buyNowSticky' ).click();
	} );
}

export function triggerFormStickyButton() {

	// Trigger Sticky Button for Next on Payment Form.
	$( '.paymentButtonSticky' ).on( 'click', function( e ){
		e.preventDefault();
		$( '#paymentButtonBottom' ).click();
	} );
}

export function submitUserForm( buttonEl ) {
	const userFormEl = buttonEl.form || document.getElementById( 'userform' );

	if ( userFormEl.querySelector( 'input#shipping_type_preset:checked' ) ) {

		// Disable all other Fieldset inputs.
		userFormEl.querySelectorAll( 'fieldset' ).forEach( fieldsetEl => {
			if ( ! fieldsetEl.matches( '#form_section_shipping_type_preset' ) ) {
				Array.from( fieldsetEl.elements ).forEach( inputEl => {
					inputEl.disabled = true
				} );
			}
		} );
	}

	// Submit manually.
	if ( ! buttonEl.form ) {
		userFormEl.requestSubmit( buttonEl );
	}
}

export function triggerUserFormButton() {
	document.querySelectorAll( '#btnCheckoutUserNext, .userButtonSticky' ).forEach( buttonEl => {
		buttonEl.addEventListener( 'click', ( ev ) => {
			if ( ! buttonEl.form ) {
				ev.preventDefault();
			}
			submitUserForm( buttonEl );
		} )
	} );
}


export function amazonPayTrigger() {

	// Start Amazon Pay.
	$( document ).on( 'submit', '#topform', function( e ) {
		if ( $( 'input[name=paymentid]:checked' ).val() === 'bestitamazon' ) {
			e.preventDefault();
			$( "#payWithAmazonDiv a" ).click();
		}
	} );
}

export function initExpressLoading() {

	// Load PaypalExpress.
	$( '.expressButton' ).on( 'click', function() {

		// Show Loading Overlay.
		EN_KO.functions.setLoading( true );
	} );
}

export function initPaypalLoading() {

	$( '.en_button--next' ).on( 'click', function() {
		if ( ! $( "#popup_bulky_goods_prompt_for_phone" ).hasClass( 'en_is_active' ) ) {

			// Show Loading Overlay.
			EN_KO.functions.setLoading( true );
		}
	} );
}

$( document ).ready( function() {

	// Initialise based on ViewController.
	const v_cl = getViewControllerName();
	switch ( v_cl ) {

		case 'basket':
			initExpressLoading();
			break;

		case 'payment':
			switchPaymentMethods();
			amazonPayTrigger();
			triggerFormStickyButton();
			break;

		case 'order':
			initPaypalLoading();
			triggerFormBottomButton();
			break;

		case 'user':
			triggerUserFormButton();
			break;
	}
} );
